
import update from 'immutability-helper';
import { compose, withState, withProps, withHandlers, lifecycle } from 'recompose';

import isEqual from 'lodash/isEqual';

export const withReportSignatures = compose(
	withState('signatureElements', 'setSignatureElements', {}),
	withState('signatureModalStates', 'setSignatureModalStates', {}),
	withProps(({ report }) => ({ 
		ready: !!report,
	})),
	withHandlers({
		registerSignatrue: ({ signatureElements, setSignatureElements }) => (type, element) => {
			if(element){
				setSignatureElements(update(signatureElements, { [type]: { $set: element } }))
			}
		},
		saveSignatrues: ({ report, signatureElements, invokeChange }) => () => {
			const modification = Object.keys(signatureElements)
				.reduce((mod, type) => ({
					...mod,
					[type] : { $set: signatureElements[type].toDataURL('image/png') }
				}), {});


			invokeChange({ signatures: modification });
		},
	}),
);
